const storePath = `state-${new Date().toISOString().split('T')[0]}`;

export const loadState = (): any => {
  try {
    const serializedState = localStorage.getItem(storePath);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any): void => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(storePath, serializedState);
  } catch {
    // ignore write errors
  }
};
